module.exports = __webpack_public_path__ + "img/bg_avatar_female_86.9e820b95.png";